import React from "react";
import GlobalStyles from "./styles/GlobalStyles";
import EventLandingPage from "./demos/EventLandingPage";

function App() {
  return (
    <>
      <GlobalStyles />
      <EventLandingPage />
      
    </>
  );
}

export default App;
